import { Tag, TagLabel, Box, Tooltip, TagProps } from '@chakra-ui/react';
import { ITag } from 'types';
import ManualCASIcon from '../../../icons/ManualCASIcon';

export const ManualCasTag = ({ tag, tagProps }: { tag: ITag; tagProps?: TagProps }) => {
  return (
    <Tooltip
      hasArrow
      placement="bottom"
      label={
        <>
          <strong>{tag.label}</strong>
          <div>
            The student&rsquo;s CAS was issued manually outside of CAS Shield. The student is not required to complete
            the CAS request on CAS Shield.
          </div>
        </>
      }
    >
      <Tag size="xs" variant="solid" data-selector="tag-manualcas" {...tagProps}>
        <Box mr="0.5">
          <ManualCASIcon />
        </Box>

        <TagLabel>{tag.label}</TagLabel>
      </Tag>
    </Tooltip>
  );
};
